import { render, staticRenderFns } from "./MyDoctor.vue?vue&type=template&id=120c58bb"
import script from "./MyDoctor.vue?vue&type=script&lang=js"
export * from "./MyDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports